import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';
import { Grid } from '@material-ui/core';
import { Fade, Slide } from '@material-ui/core';
import { AppStyles } from '../../../styles/AppTheme';
import { CustomMessageDialogStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppHelper } from '../../../helpers/AppHelper';
import { UiHelper } from '../../helpers/UiHelper';
import { Bar } from 'react-chartjs-2';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class StackedBarChartDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen || false}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth || false}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {this.props.stackedBarChartData && this.props.stackedBarChartData.length > 0 &&
            <Grid className={css(Styles.chartsContainer)} container spacing={2}>
              {this.props.stackedBarChartData.map((x, index) => {
                if (!x.datasets || x.datasets.length === 0) return ''
                return (
                  <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} >
                    <div className={css(Styles.chartOuterWrap)} >
                      <div className={css(Styles.chartBlock)} >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          {x.chartTitle &&
                            <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                          }
                        </div>
                        <Bar
                          data={{
                            labels: x.labels,
                            datasets: x.datasets,
                          }}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                              title: {
                                display: true,
                              },
                              tooltip: {
                                mode: 'index',
                                intersect: false,
                              },
                            },
                            scales: {
                              x: {
                                stacked: true,
                                ticks: {
                                  autoSkip: false,
                                },
                              },
                              y: {
                                stacked: true,
                              },
                            },
                          }}
                          height={300}
                        />

                      </div>
                    </div>
                  </Grid>
                )
              })}
            </Grid>
          }
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#121212',
    fontSize: 28,
    '@media (max-width: 1024px)': {
      fontSize: 22,
      maxWidth: '70vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  modalContent: {
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: 16,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  container: {
    width: '100%',
    position: 'relative'
  },
  chartOuterWrap: {
    minHeight: 320,   // give breathing room instead of fixed height
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    width: '100%',
    height: 'auto',   // let chart decide height
    minHeight: 300,   // (optional) give enough space per chart
    marginBottom: 10
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
})



// WEBPACK FOOTER //
// ./src/common/components/charts/StackedBarChartDialog.js